<template>
  <div id="contenedor-default-obra">
    <v-skeleton-loader v-if="$apollo.loading" type="card"></v-skeleton-loader>
    <v-card v-else flat>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                CLAVE:
              </span>
            </div>
            <div>
              <span>{{ getObra.clave }}</span>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                TIPO:
              </span>
            </div>
            <div>
              <span>
                {{ getObra.tipo.descripcion }}
              </span>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                SUBTIPO:
              </span>
            </div>
            <div>
              <span>{{ getObra.subtipo.descripcion }}</span>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                PROGRAMA:
              </span>
            </div>
            <div>
              <span class="text-uppercase">{{ getObra.programa.nombre }}</span>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                OBJETO:
              </span>
            </div>
            <div>
              <span class="text-uppercase"> {{ getObra.meta }}</span>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                MUNICIPIO:
              </span>
            </div>
            <div>
              <span class="text-uppercase"> {{ getObra.ubicacion.municipio.nombre }} </span>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                LOCALIDAD:
              </span>
            </div>
            <div>
              <span> {{ getObra.ubicacion.localidad }} </span>
            </div>
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                FECHA PROBABLE DE INICIO:
              </span>
            </div>
            <div>
              <span> {{getObra.fechaProbableInicio}} </span>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div>
              <span class="secondary--text font-weight-bold" cols="12">
                FECHA PROBABLE DE TERMINO:
              </span>
            </div>
            <div>
              <span> {{getObra.fechaProbableTermino}}</span>
            </div>
          </v-col>
        </v-row> -->
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import OBRA from '@/graphql/querys/administracion/planeacion/obra.gql';

export default {
  name: 'DefaultObra',
  data() {
    return {
    };
  },
  apollo: {
    obra: {
      query: OBRA,
      variables() {
        return {
          id: this.$route.params.idObra,
        };
      },
    },
  },
  methods: {
    formatoFecha(fecha) {
      if (!fecha) return null;
      const [year, month, day] = fecha.split('-');
      return `${month}/${day}/${year}`;
    },
  },
  computed: {
    getObra() {
      if (!this.obra) return {};
      return this.obra;
    },

  },
};
</script>

<style lang="scss">
</style>
